// import Icon from '@mui/material/Icon'

const routes = [
  {
    name: 'Home',
    route: '/'
  },
  {
    name: 'About Us',
    route: '/aboutus'
  },
  {
    name: 'Services',
    route: '/services'
  },
  {
    name: 'P&W Esthetics',
    route: '/estaboutus'
  }
]

export default routes
